export default __webpack_public_path__ + "cbf019b.png";